import React from "react";

export default function Availability({ availability }) {
  return (
    <div class="pt-3">
      <p className="fw-semibold text-primary" style={{ fontSize: "1rem" }}>
        Available job opportunities are included in the areas of:
      </p>
      <ul>
        {availability.map((item) => {
          return (
            <li key={item}>
              <p>{item}</p>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
